module.exports = __webpack_public_path__ + "static/img/drive.2b3183f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/icons/drive.png
// module id = HVCD
// module chunks = 0